import { useMutation } from '@apollo/client';
// Api
import { INIT_TIKTOK_INTEGRATION_AUTH } from 'api/auth/mutations';
// Api Types
import {
  InitTiktokIntegrationAuth,
  InitTiktokIntegrationAuthVariables,
} from 'api/auth/types/InitTiktokIntegrationAuth';

export const useInitTiktokIntegrationAuth = () => {
  return useMutation<
    InitTiktokIntegrationAuth,
    InitTiktokIntegrationAuthVariables
  >(INIT_TIKTOK_INTEGRATION_AUTH);
};
